import { Tooltip } from '@civilgrid/ui/components';
import kebabCase from 'lodash/kebabCase';
import type { ReactNode } from 'react';
import Icon from '../Icon';

interface Props {
  text: ReactNode;
  /** Names the help button for what it explains, e.g. "About preferred contact method"; `text` is its description. */
  label: string;
  /** Stable test id placed on the tooltip trigger; defaults to one derived from `label`. */
  testId?: string;
}

export default function ({ text, label, testId }: Props) {
  return (
    <Tooltip
      text={text}
      aria-label={label}
      delayDuration={200}
      sideOffset={10}
      className="max-w-[30rem]"
      triggerClassName="align-middle"
      data-testid={testId ?? `info-tooltip-${kebabCase(label)}`}
    >
      <Icon icon="help" size={12} />
    </Tooltip>
  );
}
